import { BaseResource } from "./BaseResource";
import { legacyApiResourceUrl } from "@ploy-lib/core";
export class LogEntryExcerptResource extends BaseResource {
    pk() {
        return this.id;
    }
}
LogEntryExcerptResource.urlRoot = legacyApiResourceUrl("Admin/LiveLogger/logs/{context}");
export class LogEntryResource extends BaseResource {
    pk() {
        return this.id;
    }
}
LogEntryResource.urlRoot = legacyApiResourceUrl("Admin/LiveLogger/logs/{context}/{id}");
export class LogTraceResource extends BaseResource {
    pk() {
        return "";
    }
    getContextData() {
        const result = {};
        for (const [key, value] of Object.entries(this.traces || {})) {
            if (Array.isArray(value)) {
                result[key] = value;
            }
        }
        return result;
    }
}
LogTraceResource.urlRoot = legacyApiResourceUrl("Admin/LiveLogger/logs/{context}/traces/{traceId}");
export class LoggedMessage {
}
export class LoggedHeader {
}
export class LogStatement {
}
export class ClientSpan {
}
export class DatabaseSpan {
}
//# sourceMappingURL=LogEntryResource.js.map